import { createStyles } from '@zn-material-ui'

export default () =>
  createStyles({
    helper: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      height: 54,
      width: '460px',
    },
    rememberPwd: {
      fontSize: 14,
      color: '#999',
    },
    findPassword: {
      position: 'absolute',
      left: '0',
      top: '37%',
    },
    leftButton: {
      display: 'inline-block',
      cursor: 'pointer',
      color: '#999',
      fontSize: 14,
    },
    helperRight: {
      display: 'flex',
      position: 'absolute',
      right: '0',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    pwdForgot: {
      fontSize: 14,
      color: '#999',
      cursor: 'pointer',
    },
    divider: {
      width: 1,
      height: 10,
      marginLeft: 10,
      marginRight: 10,
      border: '0.2px solid #D8D8D8',
    },
    register: {
      fontSize: 14,
      color: '#999',
      cursor: 'pointer',
    },
  })
